import { Grid, List, ListItem } from '@mui/material';
import clsx from 'clsx';
import { receiptStyles } from './styles';
import { TAX_TYPES, sortTaxes } from './utils';

interface IPROPS {
  taxRates?: TAX_TYPES;
  taxNumbers?: TAX_TYPES;
}

const TaxNumbers = ({ taxRates = {}, taxNumbers = {} }: IPROPS) => {
  const classes = receiptStyles();
  const renderTaxItem = (key: string) => (
    <ListItem
      key={key}
      className={clsx(
        classes.mt4,
        classes.p0,
        classes.font14,
        classes.gray6,
        classes.weight400,
        classes.lineHeight20,
      )}
    >
      {`${key}#: ${taxNumbers[key]}`}
    </ListItem>
  );

  return (
    <Grid container>
      <List className={classes.p0}>
        {Object.keys(sortTaxes(taxRates))
          .filter((key) => taxNumbers[key])
          .map((key) => renderTaxItem(key))}
      </List>
    </Grid>
  );
};

export default TaxNumbers;
